import request from '@/utils/request'

var api={
    get :function (url, data) {
        return request({
          url: url, 
          method: 'get',
          params: data
        })
      },
      post: function(url, data) {
        return request({
          url: url, 
          method: 'post',
          data
        })
      }
}


export  default api


// WEBPACK FOOTER //
// ./src/request/api.js